import Nav from "./nav"
import Search from "./search"
import Form from "./form"
import Slider from "./slider"
import Readmore from "./readmore"
import Tabs from "./tabs"
import VideoAutoplay from "./videoAutoplay"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Form(jQuery)
    Slider(jQuery)
    Readmore(jQuery)
    Tabs(jQuery)
    VideoAutoplay(jQuery)
})
